export default __webpack_public_path__ + "images/plot-type-full-stacked-line.8681c3324ab9fe1f29844bc16a00b4df.svg";